import styled from "styled-components"

export const Title = styled.h1`
  color: ${props=>props.isDark ? ({ theme }) => theme.palette.primary.main:({ theme }) => theme.palette.secondary.main};
  margin: 0;
  padding: 0;
`